import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import MultiselectFilter from 'components/Filter/MultiselectFilter';
import { useGetAuthFilterTypeQuery } from 'redux/hook/useFilter';

export const FEATURE_LIST = [];


const FeatureTypeFilter = ({
    defaultSelected,
    onChange,
}) => {
    const [, result] = useGetAuthFilterTypeQuery();
    const [typeOptions, setTypeOptions] = useState([]);

    useEffect(() => {
        const { data } = result ?? {};
        let list = [];
        if (data?.length) {
            list = data.map(({ type }) => ({
                text: I18n.t(`filters.features_map.${ type }`),
                value: type,
            }));
            setTypeOptions(list);
        }
        else {
            setTypeOptions([]);
        }
    }, [result]);

    return (
        <MultiselectFilter
            title={ I18n.t('filters.filter_feature') }
            options={ typeOptions }
            defaultSelected={ defaultSelected }
            onChange={ onChange }
        />
    );
};

FeatureTypeFilter.propTypes = {
    defaultSelected: PropTypes.arrayOf(PropTypes.number),
    onChange: PropTypes.func.isRequired,
};
FeatureTypeFilter.defaultProps = {
    defaultSelected: [],
};

export default FeatureTypeFilter;
